import { Schema, get } from '../../../json-transform';

export const create = new Schema({
  lists: get('lists').asArrayOfOptionValues().ifEmpty(undefined),
  user_data: get('user_data').asString().ifEmptyString(undefined),
  external_id: get('external_id').asString().ifEmptyString(undefined),
  attribute: get('attribute').ifEmpty(undefined),
  avatar: get('sample_id').as((sampleId) => `/6/samples/faces/${sampleId}`),
});
